import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {
    static amountValidator(control: AbstractControl): ValidationErrors | null {
        const pattern = /^(?:[1-9]\d*(?:\.\d{1,2})?|0\.(?:0[1-9]|[1-9]\d?))$/;

        if (!control.value) {
            return null;
        }

        return pattern.test(control.value) ? null : { invalidAmount: true };
    }

    // Like amountValidator but also accepts 0 / 0.00 (for optional amounts such as shipping and tax).
    static nonNegativeAmountValidator(control: AbstractControl): ValidationErrors | null {
        if (!control.value) {
            return null;
        }

        const pattern = /^\d+(\.\d{1,2})?$/;
        return pattern.test(control.value) ? null : { invalidAmount: true };
    }

    static usPhone(control: AbstractControl): ValidationErrors | null {
        const value = control.value?.toString().trim();
        if (!value) return null;

        const regex = /^[0-9]+$/;

        return regex.test(value) ? null : { usPhoneInvalid: true };
    }
}
